export default __webpack_public_path__ + "static/media/icon_poi_chart.b2d60630.svg";